import { Form, Select, Space, Segmented } from "antd";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";
import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";
import groupBy from "lodash/groupBy";
import sumBy from "lodash/sumBy";
import round from "lodash/round";
import meanBy from "lodash/meanBy";
import { DASHBOARD_PERMISSION } from "../../constants";

const HeaderSelector = ({
  filter,
  config,
  setFilters,
  onChange,
  stats,
  currentTheme,
  selectedSegment,
  setSelectedSegment,
}) => {
  const [form] = Form.useForm();
  const groupedMachineStatus = groupBy(stats, "status.name");
  const companies = get(config, "companies", [])
    .filter(company =>
      find(get(company, "feature_permissions", []), ['key', DASHBOARD_PERMISSION])
    )
    .map(company => ({
      label: get(company, "name"),
      value: get(company, "id"),
    }));

  return (
    <div className="flex flex-col md:flex-row justify-between px-4 py-2 bg-gray-900 rounded-xl items-center">
      <div
        className={`relative w-auto max-w-[180px] flex items-center justify-between md:justify-center h-[55px]  ${get(filter, "company") ? "shadow-md" : ""
          } `}
      >
        {get(filter, "company.logo.url") && (
          <img
            src={get(filter, "company.logo.url", "")}
            alt={`${get(filter, "company.name", "")} avatar`}
            className="object-contain object-center h-[55px] max-h-[55px]"
          />
        )}
      </div>

      <div className="text-white text-2xl md:text-3xl leading-relaxed tracking-normal font-normal drop-shadow-md">
        {get(filter, "company") && (
          <Space
            size={{ xs: 12, sm: 20, md: 24, lg: 32 }}
            wrap
            className="gap-1 sm:gap-2 md:gap-3 items-baseline"
          >
            <div>
              <span className="text-black text-sm">
                ON :{" "}
                <span className="font-black text-[#87dd49]">
                  {get(groupedMachineStatus, "ON.length") || 0}
                </span>
              </span>
            </div>
            <div>
              <span className="text-black text-sm">
                OFF :{" "}
                <span className="font-black text-[#ff6e40]">
                  {get(groupedMachineStatus, "OFF.length") || 0}
                </span>
              </span>
            </div>
            <div>
              <span className="text-black text-sm">
                IDLE :{" "}
                <span className="font-black text-[#e6e5e5]">
                  {get(groupedMachineStatus, "IDLE.length") || 0}
                </span>
              </span>
            </div>
            <>
              <div>
                <span className="text-black text-sm">
                  DISC :{" "}
                  <span className="font-black text-[#ff3d3d]">
                    {get(groupedMachineStatus, "Disconnected.length") || 0}
                  </span>
                </span>
              </div>
            </>

            <div>
              <span className="text-black text-sm">
                KWH :{" "}
                <span className="font-black text-[#9ecee4]">
                  {Math.max(round(
                    sumBy(stats, (machine) => get(machine, "total_power")),
                    1
                  ),0) || 0}
                </span>
              </span>
            </div>
  <div>
                <span className="text-black text-sm">
                  Mach. Eff. :
                  <span className="font-black text-[#ff3d3d]">
                    {' '} {Math.max(round(meanBy(stats, "meta.machine_efficiency"), 1),0)||0}%
                  </span>
                </span>
              </div>
                <div>
                <span className="text-black text-sm">
                  Prod. Eff. :
                  <span className="font-black text-[#ff3d3d]">
                    {' '} {Math.max(round(meanBy(stats, "meta.product_efficiency"), 1),0)||0}%
                  </span>
                </span>
              </div>
              <div>
                <span className="text-black text-sm">
                  OEE :
                  <span className="font-black text-[#ff3d3d]">
                    {' '} {Math.max(round(meanBy(stats, "meta.oee"), 1),0)||0}%
                  </span>
                </span>
              </div>
          </Space>
        )}
      </div>

      <div className="md:self-end min-w-[250px] flex flex-row gap-1 justify-center items-center">
        {get(filter, "company") && (
          <div className="justify-center items-center mr-4">
            <Segmented
              shape="round"
              value={selectedSegment}
              className={`${get(currentTheme, "bgPrimary")}`}
              options={[
                {
                  value: "cards",
                  icon: (
                    <AppstoreOutlined
                      style={{
                        color: selectedSegment === "table" ? "white" : "",
                      }}
                    />
                  ),
                },
                {
                  value: "table",
                  icon: (
                    <BarsOutlined
                      style={{
                        color: selectedSegment === "cards" ? "white" : "",
                      }}
                    />
                  ),
                },
              ]}
              onChange={(value) => setSelectedSegment(value)}
            />
          </div>
        )}
        {get(config, "companies.length") > 1 && (
          <Form form={form}>
            <div className="flex items-center" style={{ minHeight: '100%' }}>
              <Form.Item
                name="Company"
                label=""
                colon={false}
                className="mb-0"
                layout="inline"
              >
                <Select
                  style={{ minWidth: 250, marginBottom: "10px" }}
                  size="middle"
                  className="my-auto"
                  value={get(filter, "company")}
                  optionFilterProp="label"
                  showSearch
                  placeholder="Select Company"
                  options={companies}
                  onChange={(val) => {
                    const company = find(get(config, "companies"), ["id", val]);
                    setFilters({
                      ...filter,
                      company,
                    });
                    onChange({ company_uuid: get(company, "id") });
                  }}
                  getPopupContainer={(triggerNode) =>
                    triggerNode.parentNode || document.body
                  }
                />
              </Form.Item>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default HeaderSelector;
